import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { server } from "../utills/utils";

import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";

import Navigation from "../components/Navigations/MainNavigation";
import Spinner from "../components/Modals/SpinnerModal";
import SuccessModal from "../components/Modals/CommonModal";
import ShopImage from "../assets/store.jpg";

import Footer from "../components/Footer";

import styled from "styled-components";

const Container = styled.div`
  width: 80%;
  height: 105vh;
  padding-top: 100px;
  margin-left: 10%;
`;
const ImageContainer = styled.div`
  width: 55%;
  height: 100%;
  float: left;
`;
const Image = styled.img`
  max-width: 100%;
  max-height: 90%;
`;
const FormContainer = styled.div`
  width: 40%;
  height: 100%;
  float: right;
`;
const Title = styled.h2`
  font-size: 1.2em;
  color: #276fb7;
  margin: 0;
  padding: 0;
`;
const SubTitle = styled.p`
  font-size: 1em;
  color: #276fb7;
  margin: 0;
  padding: 5px 0 30px 0;
`;
const InputBox = styled.div`
  width: 100%;
  height: auto;
  margin-bottom: 10px;
`;
const Input = styled.input`
  width: 92.9%;
  padding: 15px 3.3%;
  font-size: 15px;
  border: 1px solid #eee;
  border-radius: 5px;
  outline: none;
  color: gray; ;
`;
const Button = styled.button`
  width: 100%;
  padding: 13px 10px;
  background: #276fb7;
  color: white;
  font-size: 1.1em;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin: 20px 0;
`;
const Success = styled.div`
  width: 100%;
  padding: 35px 0;
`;
const SuccessTitle = styled.h1`
  font-size: 1.1em;
  margin: 0 0 5px 0;
  font-weight: 500;
`;
const SuccessIntro = styled.p`
  padding: 0 13%;
  margin: 0 0 25px 0;
`;
const MerchantLink = styled(Link)`
  background: red;
  background: #f97a7a;
  padding: 10px 20px;
  color: white;
  text-decoration: none;
  border-radius: 5px;
`;
const SelectInput = styled.select`
  width: 100%;
  padding: 15px 2.5%;
  font-size: 15px;
  border: 1px solid #eee;
  border-radius: 5px;
  outline: none;
  color: gray;
`;
const SelectOption = styled.option`
  width: 100%;
`;

const TechButton = styled.button`
  padding: 10px 30px;
  margin-right: 10px;
  cursor: pointer;
  font-weight: 600;
  border: 1px solid #ccc;
  border-radius: 5px;
  color: gray;
  background: white;
  &:hover {
    color: black;
  }
`;

const TechActiveButton = styled.button`
  padding: 10px 30px;
  margin-right: 10px;
  cursor: pointer;
  font-weight: 600;
  border: 1px solid #276fb7;
  border-radius: 5px;
`;

function ShopRequest() {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [location, setLocation] = useState("");
  const [password, setPassword] = useState("");
  const [spinner, setSpinner] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [cityId, setCityId] = useState(null);
  const [thanaId, setThanaId] = useState(null);
  const [catId, setCatId] = useState(null);
  const [thanas, setThanas] = useState([]);
  const [categories, setCategories] = useState([]);
  const [cities, setCities] = useState([]);
  const [serviceType, setServiceType] = useState("");

  const nameChangeHandler = (e) => {
    setName(e.target.value);
  };
  const phoneChangeHandler = (e) => {
    setPhone(e.target.value);
  };
  const emailChangeHandler = (e) => {
    setEmail(e.target.value);
  };
  const locationChangeHandler = (e) => {
    setLocation(e.target.value);
    // console.log(e);
  };
  const thanaHandler = (e) => {
    setThanaId(e.target.value);
  };
  const cityHandler = (e) => {
    console.log("city", e.target.value);
    if (e.target.value !== "Select City") {
      setCityId(e.target.value);
      setThanas(cities[e.target.value].thanas);
    } else {
      setThanas([]);
    }
  };
  const categoryHandler = (e) => {
    if (e.target.value != "Select Category") {
      setCatId(e.target.value);
    }
  };
  const passwordChangeHandler = (e) => {
    setPassword(e.target.value);
  };

  const serviceTypeHandler = (type) => {
    setServiceType(type);
  };
  const handleSelect = (address) => {
    geocodeByAddress(address)
      .then((results) => getLatLng(results[0]))
      .then((latLng) => console.log("Success", latLng))
      .catch((error) => console.error("Error", error));
  };
  const handleRequest = async (e) => {
    try {
      e.preventDefault();
      setMessage("");
      if (name.length < 2) {
        setMessage("Enter a valid name.");
      } else if (phone[0] !== "0" || phone.length !== 11) {
        setMessage("Enter a valid phone number");
      } else if (!cityId) {
        setMessage("Select a city.");
      } else if (!thanaId) {
        setMessage("Select a thana.");
      } else if (!catId) {
        setMessage("Select a category.");
      } else if (password.length < 8) {
        setMessage("Password must be at least 8 characters.");
      } else {
        setSpinner(true);
        const shop = await axios.post(server, {
          query: `
              mutation{
                  shopRequest(
                    name: "${name}",
                    phone: "${phone}",
                    email: "${email}",
                    password: "${password}",
                    cityId:"${cities[cityId]._id}",
                    cityName:"${cities[cityId].name}",
                    thanaId:"${thanas[thanaId]._id}",
                    thanaName:"${thanas[thanaId].name}",
                    categoryId:"${categories[catId]._id}",
                    categoryName:"${categories[catId].name}",
                    serviceType:"${serviceType}"
                  ){
                      success
                      error_message
                  }

              }
            `,
        });
        console.log("Shop", shop);
        if (shop.data.data.shopRequest.success) {
          setSpinner(false);
          setSuccess(true);
          setName("");
          setPhone("");
          setEmail("");
          setLocation("");
          setPassword("");
          setMessage("");
          setCityId(null);
          setThanaId(null);
          setCatId(null);
        } else {
          setSpinner(false);
          setMessage(shop.data.data.shopRequest.error_message);
        }
      }
    } catch (error) {
      // throw error;
      console.log(error);
    }
  };
  const fetchCategories = async () => {
    try {
      const fetchCategories = await axios.post(server, {
        query: `
           query{
            allCategories{
              _id
              name
            }
           }
          
          `,
      });
      setCategories(fetchCategories.data.data.allCategories);
      console.log(fetchCategories);
    } catch (error) {
      throw error;
    }
  };
  const fetchCities = async () => {
    try {
      const cities = await axios.post(server, {
        query: `
           query{
            getCities{
              _id
              name
              thanas{
                _id
                name
              }
            }
           }
          
          `,
      });
      // if (fetchCities.data && fetchCities.data.data) {
      setCities(cities.data.data.getCities);
      console.log(cities);
      //}
    } catch (error) {
      throw error;
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    fetchCategories();
    fetchCities();
  }, []);

  return (
    <div>
      <Spinner show={spinner} />
      <SuccessModal
        show={success}
        closeModal={() => {
          setSuccess(false);
        }}
      >
        <Success>
          <SuccessTitle>
            Contragulations. Shop request successfully sent.
          </SuccessTitle>
          <SuccessIntro>
            We will contact you soon. We will be happy to help your business
            grow. Contact at 01721637269.
          </SuccessIntro>
          {/* <MerchantLink to="/merchant/login">Go to merchant panel</MerchantLink> */}
        </Success>
      </SuccessModal>
      <Navigation />
      <Container>
        <ImageContainer>
          <Image src={ShopImage} alt="shop request" />
        </ImageContainer>
        <FormContainer>
          <Title>Maplun Shop Request</Title>
          <SubTitle>Type your shop details and send us shop request</SubTitle>
          <form onSubmit={handleRequest}>
            <InputBox>
              <Input
                onChange={nameChangeHandler}
                type="text"
                value={name}
                required={true}
                placeholder="Shop name"
              />
            </InputBox>
            <InputBox>
              <Input
                onChange={phoneChangeHandler}
                type="number"
                min="0"
                value={phone}
                required={true}
                placeholder="Phone number"
              />
            </InputBox>
            <InputBox>
              <Input
                onChange={emailChangeHandler}
                type="email"
                value={email}
                placeholder="Email address(optional)"
              />
            </InputBox>
            {/* <InputBox>
              
              <Input
                onChange={locationChangeHandler}
                type="text"
                value={location}
                required={true}
                placeholder="Shop location"
              />
            </InputBox> */}
            <InputBox>
              <SelectInput onChange={cityHandler} required={true}>
                <option value={null}>Select City</option>
                {cities.map((city, id) => {
                  return <SelectOption value={id}>{city.name}</SelectOption>;
                  // return <option value={id}>{city.name}</option>;
                })}
              </SelectInput>
            </InputBox>
            <InputBox>
              <SelectInput onChange={thanaHandler} required={true}>
                <option>Select Thana</option>
                {cityId
                  ? thanas.map((th, id) => {
                      return <option value={id}>{th.name}</option>;
                    })
                  : null}
              </SelectInput>
            </InputBox>

            <InputBox>
              <SelectInput onChange={categoryHandler} required={true}>
                <option>Select Category</option>
                {categories.map((cat, id) => {
                  return <option value={id}>{cat.name}</option>;
                })}
              </SelectInput>
            </InputBox>
            {catId && categories[catId]._id == "6129e467f8785a2974c9915a" && (
              <InputBox>
                <p>Select technical service type</p>
                {serviceType && serviceType == "Professional" ? (
                  <TechActiveButton
                    onClick={() => serviceTypeHandler("Professional")}
                    type="button"
                  >
                    Professional Service
                  </TechActiveButton>
                ) : (
                  <TechButton
                    onClick={() => serviceTypeHandler("Professional")}
                    type="button"
                  >
                    Professional Service
                  </TechButton>
                )}
                {serviceType && serviceType == "Repair" ? (
                  <TechActiveButton
                    onClick={() => serviceTypeHandler("Repair")}
                    type="button"
                  >
                    Repair Service
                  </TechActiveButton>
                ) : (
                  <TechButton
                    onClick={() => serviceTypeHandler("Repair")}
                    type="button"
                  >
                    Repair Service
                  </TechButton>
                )}
              </InputBox>
            )}
            {catId && categories[catId]._id == "6129e3ebf8785a2974c9914e" && (
              <InputBox>
                <p>Select a type</p>
                {serviceType && serviceType == "Grocerry" ? (
                  <TechActiveButton
                    onClick={() => serviceTypeHandler("Grocerry")}
                    type="button"
                  >
                    Grocerry
                  </TechActiveButton>
                ) : (
                  <TechButton
                    onClick={() => serviceTypeHandler("Grocerry")}
                    type="button"
                  >
                    Grocerry
                  </TechButton>
                )}
                {serviceType && serviceType == "Food" ? (
                  <TechActiveButton
                    onClick={() => serviceTypeHandler("Food")}
                    type="button"
                  >
                    Food
                  </TechActiveButton>
                ) : (
                  <TechButton
                    onClick={() => serviceTypeHandler("Food")}
                    type="button"
                  >
                    Food
                  </TechButton>
                )}
              </InputBox>
            )}
            {catId && categories[catId]._id == "6129e403f8785a2974c99151" && (
              <InputBox>
                <p>Select a type</p>
                {serviceType && serviceType == "Computer" ? (
                  <TechActiveButton
                    onClick={() => serviceTypeHandler("Computer")}
                    type="button"
                  >
                    Computer
                  </TechActiveButton>
                ) : (
                  <TechButton
                    onClick={() => serviceTypeHandler("Computer")}
                    type="button"
                  >
                    Computer
                  </TechButton>
                )}
                {serviceType && serviceType == "Electronics" ? (
                  <TechActiveButton
                    onClick={() => serviceTypeHandler("Electronics")}
                    type="button"
                  >
                    Electronics
                  </TechActiveButton>
                ) : (
                  <TechButton
                    onClick={() => serviceTypeHandler("Electronics")}
                    type="button"
                  >
                    Electronics
                  </TechButton>
                )}
              </InputBox>
            )}
            {catId && categories[catId]._id == "6129e40ff8785a2974c99154" && (
              <InputBox>
                <p>Select a type</p>
                {serviceType && serviceType == "Mobile" ? (
                  <TechActiveButton
                    onClick={() => serviceTypeHandler("Mobile")}
                    type="button"
                  >
                    Mobile
                  </TechActiveButton>
                ) : (
                  <TechButton
                    onClick={() => serviceTypeHandler("Mobile")}
                    type="button"
                  >
                    Mobile
                  </TechButton>
                )}
                {serviceType && serviceType == "Accessories" ? (
                  <TechActiveButton
                    onClick={() => serviceTypeHandler("Accessories")}
                    type="button"
                  >
                    Accessories
                  </TechActiveButton>
                ) : (
                  <TechButton
                    onClick={() => serviceTypeHandler("Accessories")}
                    type="button"
                  >
                    Accessories
                  </TechButton>
                )}
              </InputBox>
            )}
            {catId && categories[catId]._id == "6129e455f8785a2974c99157" && (
              <InputBox>
                <p>Select a type</p>
                {serviceType && serviceType == "Furniture" ? (
                  <TechActiveButton
                    onClick={() => serviceTypeHandler("Furniture")}
                    type="button"
                  >
                    Furniture
                  </TechActiveButton>
                ) : (
                  <TechButton
                    onClick={() => serviceTypeHandler("Furniture")}
                    type="button"
                  >
                    Furniture
                  </TechButton>
                )}
                {serviceType && serviceType == "Housing" ? (
                  <TechActiveButton
                    onClick={() => serviceTypeHandler("Housing")}
                    type="button"
                  >
                    Housing
                  </TechActiveButton>
                ) : (
                  <TechButton
                    onClick={() => serviceTypeHandler("Housing")}
                    type="button"
                  >
                    Housing
                  </TechButton>
                )}
              </InputBox>
            )}
            <InputBox>
              <Input
                onChange={passwordChangeHandler}
                type="password"
                value={password}
                required={true}
                placeholder="Type password"
              />
            </InputBox>
            <p style={{ color: "red" }}>{message}</p>
            <Button type="submit">Send Request</Button>
          </form>
        </FormContainer>
      </Container>
      <Footer />
    </div>
  );
}

export default ShopRequest;
